
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import App from './App.tsx'
import './index.css'

// Create a client with improved configuration
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10, // 10 minutes - increased for device data
      refetchOnWindowFocus: false, // Reduced unnecessary refetches
      retry: 1,
      gcTime: 1000 * 60 * 60, // 1 hour - keep unused data in cache longer
      refetchOnMount: false, // Prevent refetch on component mount if data is fresh
    },
    mutations: {
      retry: 1,
    },
  },
});

const container = document.getElementById("root");

if (!container) {
  throw new Error("Failed to find the root element");
}

const root = createRoot(container);

// Set up local storage event listener for cross-tab communication
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    if (event.key === 'device-cache-updated') {
      console.log('Storage event detected in main.tsx, refreshing queries');
      queryClient.invalidateQueries();
    }
  });
}

root.render(
  <QueryClientProvider client={queryClient}>
    <App />
    {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>
);
